export default __webpack_public_path__ + "assets/images/5c57314327822738a6af763453d8ca91.png";